module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"name_label":"Name","name_placeholder":"Product name","logo_upload_button":"Upload logo"},"pt-BR":{"name_label":"Nome","name_placeholder":"Nome do produto","logo_upload_button":"Enviar um logotipo"}}')
  delete Component.options._Ctor
}
